// extracted by mini-css-extract-plugin
export default {"edit_post":"EditPost_edit_post__F4VyW"};